<template>
    <el-dialog
            :visible="isVisible"
            :width='width'
            :show-close='false'
            center
            class="dialog"
            :lock-scroll="false"
            >
            <div slot="title" class="title">
                {{title}}
            </div>
            <slot></slot>
            <ul slot="footer" class="footer">
                <li @click="isVisible = false">取消</li>
                <li @click="dialogClick">确定</li>
            </ul>
        </el-dialog>
</template>

<script>
export default {
    data(){
        return {
        }
    },
    props:{
        drawerVisible:{
            type:Boolean,
            default:false,
        },
        width: {
            type: [String],
            default: '420px'
        },
        title: {
            type: [String],
            default: '温馨提示'
        },
    },
    computed:{
        isVisible:{
            set (v) {
                this.$emit('visible', v)
            },
            get () {
                return this.drawerVisible
            }
        }
    },
    methods:{
        dialogClick(){
            this.$emit('visibleChang')
        }
    }
}
</script>
<style scoped>
.dialog >>> .el-dialog__header{
    padding: 0;
}
.dialog >>> .el-dialog__footer{
    padding: 0;
}
.dialog >>> .el-dialog__body{
    padding: 0;
}
.dialog >>> .el-dialog{
    border-radius: 5px;
}
</style>

<style lang="less" scoped>
.title{
    height:54px;
    line-height: 54px;
    font-size:18px;
    background:rgba(77,142,246,1);
    color:rgba(255,255,255,1);
    border-radius:5px 5px 0px 0px;
}

.footer{
    display: flex;
    font-size:16px;
    border-top: 1px solid #E5E5E5;
    padding: 16px 0;
    li{
        flex: 1;
        cursor:pointer;
    }
    li:nth-child(2){
        color:#4D8EF6;
        border-left: 1px solid #E5E5E5;
    }
}
</style>